import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export const useQuery = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [queryString] = useSearchParams();
  const query = Object.fromEntries(queryString);

  const queryToStringify = (object) => {
    const arrayWithQuery = Object.entries(object)
      .filter((param) => !!param[1])
      .map((param) => param.join('='));

    return `?${arrayWithQuery.join('&')}`;
  };

  const setQuery = (search) => navigate({
    pathname,
    search: queryToStringify(search),
  }, { replace: true });

  return {
    query,
    setQuery,
    queryToStringify,
  };
};
